module.exports = __webpack_public_path__ + "09_hair_silver.4f197c50.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/09_hair_silver.png
// module id = T7IZ
// module chunks = 0